import { Component, inject, OnInit } from "@angular/core";
import { MarkdownModule } from "ngx-markdown";
import { DynamicDialogConfig } from "primeng/dynamicdialog";
import { DocumentsSpaceMessage } from "src/app/modules/documents-space/documents-space.model";

@Component({
  selector: "app-documents-space-chat-readonly",
  standalone: true,
  imports: [MarkdownModule],
  templateUrl: "./documents-space-chat-readonly.component.html",
  styleUrls: ["./documents-space-chat-readonly.component.scss"],
})
export class DocumentsSpaceChatReadonlyComponent implements OnInit {
  private readonly dialogConfig: DynamicDialogConfig<{
    messages: DocumentsSpaceMessage[];
  }> = inject(DynamicDialogConfig);
  messages: DocumentsSpaceMessage[] = [];
  ngOnInit(): void {
    if (this.dialogConfig.data?.messages) {
      this.messages = this.dialogConfig.data.messages;
    }
  }
}
